var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "400.000000pt",
    height: "200.000000pt",
    viewBox: "0 0 400.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "#969494",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1190 1308 c0 -74 1 -78 23 -78 43 -1 103 -37 128 -76 22 -35 24 -50 24 -149 0 -99 -2 -114 -24 -149 -25 -39 -85 -75 -128 -76 -22 0 -23 -4 -23 -75 l0 -75 48 0 c71 0 162 48 213 112 57 73 72 134 67 286 -3 115 -6 132 -31 184 -46 94 -128 152 -237 166 l-60 9 0 -79z",
    fill: "#969494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973 1363 c-63 -22 -135 -92 -165 -160 -49 -110 -46 -309 7 -412 47 -94 152 -161 252 -161 l43 0 0 74 0 73 -41 7 c-98 16 -139 81 -139 221 0 140 41 206 136 221 l44 6 0 74 0 74 -47 -1 c-27 0 -67 -7 -90 -16z",
    fill: "#969494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3569 1367 c-56 -21 -97 -54 -125 -103 -23 -39 -26 -53 -22 -114 3 -59 8 -74 34 -107 46 -57 95 -79 229 -101 104 -18 123 -24 142 -47 29 -33 29 -47 1 -79 -57 -65 -260 -48 -283 24 -6 18 -15 20 -81 20 -69 0 -74 -1 -74 -22 0 -37 40 -106 82 -142 58 -50 114 -66 233 -66 94 0 107 2 164 31 188 94 160 345 -45 402 -32 9 -93 21 -134 28 -96 14 -120 29 -120 74 0 45 36 65 117 65 58 0 123 -26 123 -50 0 -6 31 -10 76 -10 l77 0 -6 37 c-8 47 -51 100 -112 138 -43 26 -57 30 -144 32 -63 2 -109 -1 -132 -10z",
    fill: "#969494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1005 l0 -365 81 0 81 0 -6 230 c-2 127 -1 230 3 230 4 0 93 -103 197 -230 l189 -230 68 0 67 0 0 365 0 365 -75 0 -75 0 0 -232 -1 -233 -32 35 c-17 20 -105 124 -195 233 l-163 197 -69 0 -70 0 0 -365z",
    fill: "#969494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 1005 l0 -365 75 0 75 0 0 130 0 130 78 0 78 0 74 -130 74 -130 83 0 c46 0 83 2 83 4 0 2 -34 64 -76 137 l-76 132 28 21 c52 38 84 80 101 134 39 122 -36 256 -163 291 -22 6 -126 11 -236 11 l-198 0 0 -365z m423 195 c45 -36 44 -102 -2 -137 -11 -8 -59 -12 -143 -13 l-128 0 0 85 0 85 124 0 c108 0 126 -2 149 -20z",
    fill: "#969494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2350 1005 l0 -365 255 0 255 0 0 75 0 75 -180 0 -180 0 0 290 0 290 -75 0 -75 0 0 -365z",
    fill: "#969494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2720 1364 c0 -4 59 -109 131 -235 l130 -228 2 -130 2 -131 78 0 77 0 0 133 1 132 133 230 134 230 -76 3 c-41 2 -80 1 -86 -1 -6 -3 -49 -73 -96 -156 -46 -83 -86 -151 -89 -151 -4 0 -44 69 -91 153 l-85 152 -83 3 c-45 2 -82 0 -82 -4z",
    fill: "#969494"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientLogo);
export default __webpack_public_path__ + "static/media/ClientLogo.a0ce14b2e5b260d81fcd4e9eca19edbd.svg";
export { ForwardRef as ReactComponent };